export const toggleLoginComp = () => {
    return {
      type: 'TOGGLE_LOGIN_COMP'
    };
  };